import { combineReducers } from "redux";
import { changeLangRed } from "./changeLangReducer";
import { getSalonReducer } from "./getSalonReducer";

const combineReducer = combineReducers({
  getSalonReducer: getSalonReducer,
  changeLangRed: changeLangRed,
});

export default combineReducer;
